export const METEO_LINK = "https://www.meteogalicia.gal/web/predicion/concellos/";
